/**
 * Which launches this layer has already taken.
 *
 * A launch can now arrive twice on purpose - once over the socket and once from
 * the poll that exists to catch what the socket drops - and the backend can also
 * re-send a broadcast job. The launch_id is the same every time, so it is what
 * says a delivery is a repeat.
 *
 * Kept in storage as well as in memory: the layer reloads itself between ads
 * (needs_reload) and a reload that forgot would play the next poll's copy of an
 * ad it had just finished. Storage may be unavailable or throw in OBS; the
 * ledger then works from memory alone and the page stays correct.
 */

const KEY = 'ad_launch_ledger'
export const LEDGER_LIMIT = 50

export function createLaunchLedger (storage, limit = LEDGER_LIMIT) {
  let ids = []

  try {
    const stored = JSON.parse(storage.getItem(KEY))
    if (Array.isArray(stored)) ids = stored.filter(id => typeof id === 'string').slice(-limit)
  } catch (e) {
    void e
  }

  function persist () {
    try {
      storage.setItem(KEY, JSON.stringify(ids))
    } catch (e) {
      void e
    }
  }

  return {
    has (id) {
      return ids.indexOf(String(id)) !== -1
    },
    /** True the first time an id is seen, false for every repeat. */
    claim (id) {
      const key = String(id)
      if (ids.indexOf(key) !== -1) return false
      ids.push(key)
      if (ids.length > limit) ids = ids.slice(-limit)
      persist()
      return true
    }
  }
}

export default createLaunchLedger
